import { render, staticRenderFns } from "./MyOrderItem.vue?vue&type=template&id=844e73a4&"
import script from "./MyOrderItem.vue?vue&type=script&lang=js&"
export * from "./MyOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports